import * as React from "react";

interface IProps {
    className?: string;
}

class IconHBRPlay extends React.Component<IProps> {
    public render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className={this.props.className} viewBox="0 0 19 26">
                <polygon points="0.5,0.5 0.5,25.5 18.53,13 " />
            </svg>
        );
    }
}

export default IconHBRPlay;
